import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { Info } from 'react-feather'

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    TooltipApprovalInfo,
    CustomDropDown
} from 'common'

export const TablePaymentReception = ({ useFetchInit }) => {
    
    const {
        //------------- Generales
        //------------- globalStates
        // globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    // const { showForm } = globalStates
    
    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    
    // ------------------------------------------------ FetchData
    const { fetchAllPaymentReception } = FetchData
    const { dataPaymentReception, loadingFetchAllPaymentReception } = fetchAllPaymentReception

    // ------------------------------------------------ Actions
    const { 
        handleClickFetchSpecificPaymentReception
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "movimiento_fecha", headerName: "FECHA", minWidth: 150, filter: true },
        { 
            field: "movimiento_tipo", headerName: "TIPO", minWidth: 100, filter: true,
            cellClass: (params) => {
                return params.value === 'EFECTIVO' ? 'bg-primary' : 'bg-secondary text-white';
            },
        },
        { field: "nombre_banco", headerName: "BANCO", minWidth: 150, maxWidth: 150, filter: true },
        { field: "boleta_numero", headerName: "BOLETA", minWidth: 200, filter: true },
        { field: "movimiento_moneda", headerName: "MONEDA", minWidth: 120, maxWidth: 120, filter: true },
        { field: "movimiento_quetzales", headerName: "TOTAL (Q)", minWidth: 120, maxWidth: 120, filter: true },
        { field: "movimiento_dolares", headerName: "TOTAL ($)", minWidth: 120, maxWidth: 120, filter: true },
        { 
            field: "aprobacion_check",
            headerName: "APROBACION",
            minWidth: 175,
            maxWidth: 175,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "left"
            }),
            cellClass: (params) => {

                if(params.value === 'APROBADO') return 'bg-success';
                if(params.value === 'PENDIENTE') return 'bg-warning';
                if(params.value === 'RECHAZADO') return 'bg-danger';

            },
            cellRenderer: (params) => {
                const { value } = params
                const { aprobacion_usuario, aprobacion_fecha } = params.data

                return (
                    <TooltipApprovalInfo
                        texto_approval={value}
                        usuario_approval={aprobacion_usuario}
                        fecha_approval={aprobacion_fecha}
                    />
                )
            }
        },
        {
            headerName: "OPCIONES",
            minWidth: 400,
            cellRenderer: (params) => {
                const { idtransaction, estado } = params.data

                return (
                    <CustomDropDown color={(estado===1)?'inherit':'error'}>
                        <MenuItem
                            onClick={() => handleClickFetchSpecificPaymentReception(idtransaction, 'READONLY')}
                        >
                            <ListItemIcon> <Info color="black"/> </ListItemIcon>
                            <ListItemText primary="Informacion" />
                        </MenuItem>
                    </CustomDropDown>
                )
            }
        },
    ]

    return (
        <div className='content'>
            {(loadingFetchAllPaymentReception)&&(<LinearLoading />)}
            <CustomTableData 
                // datos (listados, individuales)
                rowConfig={dataPaymentReception}
                columnConfig={columnConfig}
                // handleClicks
                // Funciones
            />
        </div>
    )
}
